import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { AuthService, GenericError } from '@auth0/auth0-angular';
import { filter, mergeMap } from 'rxjs/operators';
import { MercatusToastyService, PROGRESS_TOAST_KEY } from './shared/services/mercatus-toasty.service';

// Errors after which the session can only be renewed by logging in again
const LOGIN_REQUIRED_ERRORS = ['login_required', 'missing_refresh_token', 'invalid_grant'];

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AppComponent implements OnInit {

    readonly progressToastKey = PROGRESS_TOAST_KEY;

    constructor(public toastyService: MercatusToastyService, private auth: AuthService) {}

    ngOnInit() {
        this.auth.error$
            .pipe(
                filter(e => e instanceof GenericError && LOGIN_REQUIRED_ERRORS.includes(e.error)),
                mergeMap(() => this.auth.loginWithRedirect())
            )
            .subscribe();
    }
}
